import {ComponentService} from "./service/component";
import {Application} from "./application/application";

import {AosInit} from "./components/aos-init";
import {SocialComponent} from "./components/social";
import {MobileMenu} from "./components/mobile-menu";
import {ModalComponent} from "./components/modal";
import {SelectricComponent} from "./components/selectric";
import {HeaderScroll} from "./components/header-scroll";
import {DesktopMenuComponent} from "./components/desktop-menu";
import {VideoComponent} from "./components/video";
import {LenisScrollComponent} from "./components/lenis-scroll";
import {FeatureGridComponent} from "./components/feature-grid";
import {ProductRangeComponent} from "./components/product-range";
import {TextWithImageComponent} from "./components/text-with-image";
import Events from "./service/events";

require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {

    let components = new ComponentService();

    (<any>window).events = undefined === (<any>window).events ? new Events() : (<any>window).events;

    components.addComponent('body', AosInit, 'AosInit');
    components.addComponent('body', LenisScrollComponent, 'LenisScrollComponent');
    components.addComponent('.js-share', SocialComponent, 'SocialComponent');
    components.addComponent('.js-nav-toggle', MobileMenu, 'MobileMenu');
    components.addComponent('.js-modal-trigger', ModalComponent, 'ModalComponent');
    components.addComponent('.js-custom-select', SelectricComponent, 'SelectricComponent');
    components.addComponent('.js-nav-header', HeaderScroll, 'HeaderScrollComponent');
    components.addComponent('.js-primary-navigation', DesktopMenuComponent, 'DesktopMenuComponent');
    components.addComponent('.js-video', VideoComponent, 'VideoComponent');
    components.addComponent('.js-feature-grid-overlay', FeatureGridComponent, 'FeatureGridComponent');
    components.addComponent('.js-product-carousel', ProductRangeComponent, 'ProductRangeComponent');
    components.addComponent('.js-text-image-carousel', TextWithImageComponent, 'TextWithImageComponent')

    new Application(components, (<any>window).events);

}))(jQuery);
